export default __webpack_public_path__ + "static/media/icon-cosmostation.758fc19c.svg";